import React from "react";
import { Box } from "@mui/material";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import {
  leftActionTabs,
  rightActionTabs,
} from "app/utils/constants/actionTabs";
import { StyledJumboRqTabs } from "components/withStyledTabs";

const ContentHeader = ({
  isAdmin,
  onAction,
  allowedActions = [],
  showLeftTabs = true,
  actionLabels = {},
  entityConfig,
}) => {
  // Filter allowedActions based on entityConfig.isUpdate and isAdd
  const filteredAllowedActions = allowedActions.filter((action) => {
    if (action === "update" && entityConfig?.isUpdate === false) {
      return false;
    }
    if (action === "add" && entityConfig?.isAdd === false) {
      return false;
    }
    return true;
  });

  const mergeLabels = (tabs) =>
    tabs.map((tab) => ({
      ...tab,
      name: actionLabels[tab.id] || tab.name,
    }));

  const filteredLeftTabs = mergeLabels(
    leftActionTabs.filter((tab) => filteredAllowedActions.includes(tab.id))
  );
  const filteredRightTabs = mergeLabels(
    rightActionTabs.filter((tab) => filteredAllowedActions.includes(tab.id))
  );

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
        {showLeftTabs && filteredLeftTabs.length > 0 && (
          <StyledJumboRqTabs
            data={filteredLeftTabs}
            map={{ label: "name" }}
            primaryKey={"id"}
            onChange={onAction}
            sx={{ minWidth: 100 }}
          />
        )}
        <Breadcrumb />
      </Box>
      {isAdmin && filteredRightTabs.length > 0 && (
        <StyledJumboRqTabs
          data={filteredRightTabs}
          map={{ label: "name" }}
          primaryKey={"id"}
          onChange={onAction}
        />
      )}
    </Box>
  );
};

export default ContentHeader;
